import { InternalLink } from '@/atoms/InternalLink'
import { AngelLogo } from '@/atoms/Logos/AngelLogo'
import { paths } from '@/constants'
import { useUser } from '@/services/UserService'
import { ProjectComboSelector } from '@/views/GuildCreateProjectsView/dashboard/ProjectComboSelector'
import { FilmmakerMenu } from '../components/FilmmakerMenu'

export const GuildProjectNav = () => {
  const { isLoggedIn } = useUser()

  return (
    <div className="flex items-center justify-between border-b border-b-gray-200 py-4 lg:pt-0">
      <InternalLink href={isLoggedIn ? paths.watch.index : paths.home}>
        <AngelLogo className="min-w-[50px]" color="black" />
      </InternalLink>
      <div className="flex items-center gap-4">
        <div className="hidden lg:flex">
          <ProjectComboSelector />
        </div>
        <div className="hidden lg:flex">
          <FilmmakerMenu />
        </div>
      </div>
    </div>
  )
}
